import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	infoIconSize: {
		width: 16,
		height: 16
	},
	danger: {
		color: colors.red[400]
	},
	iconButton: {
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor("transparent")
		}
	}
})

export default useStyles
